/* eslint-disable space-before-function-paren */
/* eslint-disable multiline-ternary */
import React, { useContext, useEffect, useState } from 'react';
import { Context as Auth } from '../../../services/auth/AuthContext';
import { Button, Table, Collapse } from 'antd';
import { useNavigate, useParams } from 'react-router-dom';
import Spinner from '../../../components/navigation/Spinner';
import '../../../components/layout/layout.css';
import {
  getProgramSessionSummary,
  getProgramSessionByMonth,
  getProgramSessionForSessions
} from '../../../services/programsession.service';
import { useTranslation } from 'react-i18next';
import { capitalize, capitalizeAll } from '../../../utils/utils';
import {
  getCenterByQuery,
  getCenterById
} from '../../../services/center.service';
import moment from 'moment';
import 'moment/locale/es';
import { set } from 'date-fns';
import { on } from 'commander';

const Sessions = (props) => {
  const { user } = useContext(Auth);
  const [loading, setLoading] = useState(true);
  const [monthLoading, setMonthLoading] = useState(false);
  const [monthSessions, setMonthSessions] = useState([]);
  const [sessionsSummary, setSessionsSummary] = useState(null);
  const [center, setCenter] = useState(null);
  const { t } = useTranslation();
  const { Panel } = Collapse;

  useEffect(() => {
    if (user.account) {
      if (user.account.roles.indexOf('organizer') >= 0) {
        loadCenter();
      } else if (user.account.roles.indexOf('trainer') >= 0) {
        loadCenterId();
      }
    }
  }, [user.account]);

  const loadCenter = async () => {
    const { status, data } = await getCenterByQuery(
      { organizer: user.account._id },
      user.token
    );
    if (status === 200) {
      await loadSummary(data.data[0]._id);
      setCenter(data.data[0]);
    }
  };

  const loadCenterId = async () => {
    const { status, data } = await getCenterById(
      user.account.center,
      user.token
    );
    if (status === 200) {
      await loadSummary(data.data._id);
      setCenter(data.data);
    }
  };

  const loadSummary = async (centerId) => {
    const { status, data } = await getProgramSessionSummary(
      { center: centerId },
      user.token
    );
    if (status === 200) {
      setSessionsSummary(data.data);
      setLoading(false);
    }
  };

  const loadMonthSessions = async (month) => {
    setMonthLoading(true);
    const { status, data } = await getProgramSessionByMonth(
      { center: center._id, month: month },
      user.token
    );
    if (status === 200) {
      setMonthSessions(data.data);
      setMonthLoading(false);
    }
  };

  // const date = moment(programSession.timestamp.updatedAt).format('MMMM YYYY');

  const columns = [
    {
      title: capitalize(t('sessions')),
      // dataIndex: ['name', 'surname', 'email', 'phone'],
      key: 'all',
      // eslint-disable-next-line react/display-name
      render: (record) => {
        return (
          <React.Fragment>
            {moment(record.closed).format('DD/MM/YYYY HH:mm')}
            <br />
            {record.account.name} {record.account.surname}
            <br />
            {record.account.dni}
            <br />
            {record.closed ? (
              <Button type='link' onClick={() => {}}>
                {t('lastSessions')}
              </Button>
            ) : (
              <>{capitalizeAll(t('activeSession'))}</>
            )}
          </React.Fragment>
        );
      },
      sorter: {
        compare: (a, b) => new Date(b.closed) - new Date(a.closed),
        multiple: 1
      },
      responsive: ['xs']
    },
    {
      title: capitalize(t('date')),
      key: 'date',
      render: (record) => (
        <React.Fragment>
          {moment(record.closed).format('DD/MM/YYYY HH:mm')}
        </React.Fragment>
      ),
      sorter: {
        compare: (a, b) => new Date(b.closed) - new Date(a.closed),
        multiple: 1
      },
      responsive: ['sm']
    },
    {
      title: capitalize(t('user')),
      key: 'user',
      // eslint-disable-next-line react/display-name
      render: (record) => {
        return (
          <React.Fragment>
            {record.account.name} {record.account.surname}
            <br />
          </React.Fragment>
        );
      },
      sorter: {
        compare: (a, b) =>
          (a.account.name + ' ' + a.account.surname).localeCompare(
            b.account.name + ' ' + b.account.surname
          ),
        multiple: 1
      },
      responsive: ['sm']
    },
    {
      title: capitalize(t('nif')),
      key: 'dni',
      // eslint-disable-next-line react/display-name
      render: (record) => {
        return (
          <React.Fragment>
            {record.account.nif}
            <br />
          </React.Fragment>
        );
      },
      responsive: ['sm']
    },
    {
      title: capitalize(t('actions')),
      key: 'actions',
      render: (record) => (
        <React.Fragment>
          {record.closed ? (
            <a
              style={{
                color: '#222',
                padding: 8,
                border: '1px solid #999',
                borderRadius: 3
              }}
              href={
                process.env.REACT_APP_API_URL +
                'programsession/downloadpdf?id=' +
                record._id
              }
              target='_blank'
              rel='noopener noreferrer'
            >
              {capitalize(t('lastSessions'))}
            </a>
          ) : (
            <>{capitalizeAll(t('activeSession'))}</>
          )}

          {/* <Button type="ghost" onClick={() => {
            getSessionPdf(record._id);
          }}>{capitalize(t('lastSessions'))}</Button> */}
        </React.Fragment>
      ),
      responsive: ['sm']
    }
  ];

  function onChangeCollapse(month) {
    console.log('params', month);
    if (month && month !== undefined) {
      loadMonthSessions(month);
    } else {
      setMonthSessions([]);
    }
  }

  const renderMonthPanel = (session) => {
    return (
      <Panel
        header={<b>{moment(session._id, 'YYYY-MM').format('MMMM YYYY')}</b>}
        key={session._id}
        extra={session.count + ' ' + capitalize(t('sessions'))}
      >
        {monthLoading ? (
          <Spinner />
        ) : (
          <Table
            columns={columns}
            dataSource={monthSessions}
            rowKey={(record) => record._id}
          />
        )}
      </Panel>
    );
  };

  if (loading) {
    return <Spinner />;
  } else {
    return (
      <>
        <div>
          {/* eslint-disable-next-line react/no-unescaped-entities */}
          <b> {capitalize(t('sessions'))}</b>
        </div>
        <Collapse
          // defaultActiveKey={['1']}
          expandIconPosition={'start'}
          onChange={(month) => onChangeCollapse(month)}
          accordion={true}
          style={{ marginTop: '10px' }}
        >
          {sessionsSummary && sessionsSummary.length > 0 ? (
            sessionsSummary.map((session) => renderMonthPanel(session))
          ) : (
            <div style={{ marginTop: 10 }}>
              {capitalize(t('noSessionsFound'))}
            </div>
          )}
        </Collapse>
        {/* <Table columns={columns} dataSource={programSessions} onChange={onChange} onRow={(record, rowIndex) => { */}
        {/*  return { */}
        {/*    onClick: event => {}, // click row */}
        {/*    onDoubleClick: event => {}, // double click row */}
        {/*    onContextMenu: event => {}, // right button click row */}
        {/*    onMouseEnter: event => {}, // mouse enter row */}
        {/*    onMouseLeave: event => {} // mouse leave row */}
        {/*  }; */}
        {/* }} rowClassName={'row-pointer'} */}
        {/* /> */}
        <br />
      </>
    );
  }
};

export default Sessions;
